function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavicon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1076,
  height: 1076,
  style: {
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 0.999
  },
  fill: "#fefefe",
  d: "M-.5-.5h1076v313h-1a1763.194 1763.194 0 0 0-180 17.5c-29.366 4.844-58.699 9.678-88 14.5-75.713-103.507-178.046-151.007-307-142.5-104.209 12.156-186.042 60.989-245.5 146.5-16.283 24.234-29.117 50.234-38.5 78h-1a5830.825 5830.825 0 0 1-131-62.5 1886.243 1886.243 0 0 0-84-35.5V-.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#fefefe",
  d: "M711.5 364.5a4649.038 4649.038 0 0 0-178 42.5 29187.28 29187.28 0 0 1-224 58.5 23.91 23.91 0 0 1-9-2.5c-2.044-.498-3.378-1.665-4-3.5 20.147-61.653 58.48-108.487 115-140.5 72.43-38.243 146.43-41.576 222-10 29.761 13.366 55.761 31.866 78 55.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#93c2e3",
  d: "M1074.5 312.5v49c-75.561 16.744-148.894 40.078-220 70-1.068.934-2.401 1.268-4 1-10.943-31.22-25.61-60.553-44-88 29.301-4.822 58.634-9.656 88-14.5a1763.194 1763.194 0 0 1 180-17.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#c4ddf0",
  d: "M-.5 328.5a1886.243 1886.243 0 0 1 84 35.5 5830.825 5830.825 0 0 0 131 62.5 417.493 417.493 0 0 0-15 66v1a5516.292 5516.292 0 0 1-144 31h-3a1237.268 1237.268 0 0 0-53-18v-178Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#7bb0da",
  d: "M1074.5 361.5v44a3092.142 3092.142 0 0 0-220 26c71.106-29.922 144.439-53.256 220-70Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#93c2e3",
  d: "M711.5 364.5c24.275 23.631 42.609 51.298 55 83a1976.887 1976.887 0 0 0-71 12.5 68852.178 68852.178 0 0 0-251 51.5 5.727 5.727 0 0 1-3 1 1717.75 1717.75 0 0 1-132-46v-1a29187.28 29187.28 0 0 0 224-58.5 4649.038 4649.038 0 0 1 178-42.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#a5c9e7",
  d: "M865.5 569.5a454.199 454.199 0 0 0-1-71 1653.85 1653.85 0 0 0 68-24.5c47.253-19.13 94.59-37.963 142-56.5.32 9.916-.01 19.75-1 29.5a31744.51 31744.51 0 0 0-208 122.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#0f5e89",
  d: "M214.5 426.5h1a1190.834 1190.834 0 0 0 80 34 87.925 87.925 0 0 0-2 9c.172.992-.162 1.658-1 2-.235-.597-.735-.93-1.5-1a2027.488 2027.488 0 0 1-91.5 22 417.493 417.493 0 0 1 15-66Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#fefefe",
  d: "M766.5 447.5c2.568 5.025 4.568 10.359 6 16a1886.274 1886.274 0 0 1-191 73.5 60.931 60.931 0 0 1-11 .5 845.343 845.343 0 0 1-125-24.5c-.556-.383-.889-.883-1-1.5a68852.178 68852.178 0 0 1 251-51.5c23.602-4.6 47.268-8.767 71-12.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#d5e6f4",
  d: "M1074.5 312.5h1v203a9907.507 9907.507 0 0 0-211 61 51.569 51.569 0 0 1 1-7 31744.51 31744.51 0 0 1 208-122.5c.99-9.75 1.32-19.584 1-29.5a12783.424 12783.424 0 0 0-142 56.5 1653.85 1653.85 0 0 1-68 24.5 342.079 342.079 0 0 0-14-66c1.599.268 2.932-.066 4-1a3092.142 3092.142 0 0 1 220-26v-93Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#bcd8ec",
  d: "M296.5 459.5c.622 1.835 1.956 3.002 4 3.5a23.91 23.91 0 0 0 9 2.5v1l-16 3a87.925 87.925 0 0 1 2-9c0-.667.333-1 1-1Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#d5e6f4",
  d: "M772.5 463.5c6.884 19.291 10.55 39.291 11 60-68.478 16.706-137.811 21.706-208 15-1.915.284-3.581-.049-5-1a60.931 60.931 0 0 0 11-.5 1886.274 1886.274 0 0 0 191-73.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#72a9d7",
  d: "M309.5 466.5a1717.75 1717.75 0 0 0 132 46 8062.893 8062.893 0 0 1-156 31v-24a298.74 298.74 0 0 1 7-48c.838-.342 1.172-1.008 1-2l16-3Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#08487a",
  d: "M292.5 471.5a298.74 298.74 0 0 0-7 48 159.408 159.408 0 0 1-3 24.5 2524.306 2524.306 0 0 1-82 14.5 5.727 5.727 0 0 1-3 1v-1a297.32 297.32 0 0 1 2-65v-1a2027.488 2027.488 0 0 0 91.5-22c.765.07 1.265.403 1.5 1Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#72a9d7",
  d: "M199.5 493.5a297.32 297.32 0 0 0-2 65c-48.375-7.595-95.708-18.928-142-34 48.019-9.667 96.019-20 144-31Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#a4c8e6",
  d: "M-.5 506.5a1237.268 1237.268 0 0 1 53 18 1852.968 1852.968 0 0 1-53 10v-28Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#c4ddf0",
  d: "M444.5 511.5c.111.617.444 1.117 1 1.5a845.343 845.343 0 0 0 125 24.5c1.419.951 3.085 1.284 5 1-93.801 29.315-189.801 39.648-288 31a171.227 171.227 0 0 1-2-26 8062.893 8062.893 0 0 0 156-31 5.727 5.727 0 0 0 3-1Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 0.997
  },
  fill: "#fefefe",
  d: "M1075.5 515.5v560H-.5v-488a4052.522 4052.522 0 0 1 51-6 18.452 18.452 0 0 1 6 .5 1020.996 1020.996 0 0 0 156 56.5c.667 0 1 .333 1 1 34.471 101.639 101.804 171.806 202 210.5 87.661 31 173.994 27.667 259-10a2023.197 2023.197 0 0 1 37.5-19.5c34.586 33.524 76.086 49.024 124.5 46.5 13.427-1.136 25.26-5.97 35.5-14.5 9.896-11.808 11.896-24.808 6-39a416.478 416.478 0 0 0-48.5-48.5 572.364 572.364 0 0 1-28-29c34.431-47.72 55.431-100.887 63-159.5a9907.507 9907.507 0 0 1 211-61Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#a5c9e7",
  d: "M783.5 523.5c1.488 26.938-1.845 53.271-10 79a2131.882 2131.882 0 0 1-262 55.5 1469.747 1469.747 0 0 1-59 5.5 537.57 537.57 0 0 1-72-11.5 970.36 970.36 0 0 1-75.5-20.5c-.399.228-.565.562-.5 1l-2-3a294.57 294.57 0 0 1-15-59v-1c98.199 8.648 194.199-1.685 288-31 70.189 6.706 139.522 1.706 208-15Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#5f99ce",
  d: "M52.5 524.5h3c46.292 15.072 93.625 26.405 142 34v1a1710.671 1710.671 0 0 1-96 14 1167.737 1167.737 0 0 0-102-27v-12a1852.968 1852.968 0 0 0 53-10Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#105e89",
  d: "M285.5 519.5v24c.007 8.729.673 17.396 2 26v1a1479.29 1479.29 0 0 1-86-10.5c-.556-.383-.889-.883-1-1.5a2524.306 2524.306 0 0 0 82-14.5 159.408 159.408 0 0 0 3-24.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#7bb0da",
  d: "M-.5 546.5c34.546 7.5 68.546 16.5 102 27v1a1918.268 1918.268 0 0 1-50 6 923.18 923.18 0 0 0-52-24v-10Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#93c2e3",
  d: "M-.5 556.5a923.18 923.18 0 0 1 52 24c-.667 0-1 .333-1 1a4052.522 4052.522 0 0 0-51 6v-31Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#a4c8e6",
  d: "m197.5 559.5 5 42a3010.007 3010.007 0 0 1-94-26.5 24.935 24.935 0 0 0-7-.5v-1a1710.671 1710.671 0 0 0 96-14Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#0c5584",
  d: "M200.5 558.5c.111.617.444 1.117 1 1.5a1479.29 1479.29 0 0 0 86 10.5 294.57 294.57 0 0 0 15 59c-.235.597-.735.93-1.5 1a7101.05 7101.05 0 0 1-97.5-28c-.667 0-1-.333-1-1l-5-42a5.727 5.727 0 0 0 3-1Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#d5e6f4",
  d: "M101.5 574.5c2.357-.163 4.69.003 7 .5a3010.007 3010.007 0 0 0 94 26.5c0 .667.333 1 1 1a709.988 709.988 0 0 0 9 36 1020.996 1020.996 0 0 1-156-56.5 18.452 18.452 0 0 0-6-.5c0-.667.333-1 1-1a1918.268 1918.268 0 0 0 50-6Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#0f628b",
  d: "M203.5 602.5a7101.05 7101.05 0 0 0 97.5 28c.765-.07 1.265-.403 1.5-1l2 3a229.73 229.73 0 0 0 12 26c-1.122.656-2.455.989-4 1a1287.212 1287.212 0 0 1-99-20c0-.667-.333-1-1-1a709.988 709.988 0 0 1-9-36Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#c5ddf0",
  d: "M773.5 602.5a101.128 101.128 0 0 1-6 15c-100.648 43.903-205.648 59.57-315 47v-1a1469.747 1469.747 0 0 0 59-5.5 2131.882 2131.882 0 0 0 262-55.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#fefefe",
  d: "M767.5 617.5a326.06 326.06 0 0 1-17.5 38c-4.223 17.556-.557 33.223 11 47a272.048 272.048 0 0 0 36.5 31.5c-44.035-8.497-87.035-4.497-129 12a536.545 536.545 0 0 0-40 18c-84.129 32.718-163.795 24.384-239-25-29.898-20.721-53.564-46.888-71-78.5a810.222 810.222 0 0 0 134 4c109.352 12.57 214.352-3.097 315-47Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#d5e6f4",
  d: "M452.5 663.5v1a810.222 810.222 0 0 1-134-4l-2-2a229.73 229.73 0 0 1-12-26c-.065-.438.101-.772.5-1a970.36 970.36 0 0 0 75.5 20.5 537.57 537.57 0 0 0 72 11.5Z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    opacity: 1
  },
  fill: "#136c91",
  d: "M806.5 344.5c18.39 27.447 33.057 56.78 44 88a342.079 342.079 0 0 1 14 66 454.199 454.199 0 0 1 1 71 51.569 51.569 0 0 0-1 7c-7.569 58.613-28.569 111.78-63 159.5a572.364 572.364 0 0 0 28 29c17.5 14.833 33.667 31 48.5 48.5 5.896 14.192 3.896 27.192-6 39-10.24 8.53-22.073 13.364-35.5 14.5-48.414 2.524-89.914-12.976-124.5-46.5a2023.197 2023.197 0 0 0-37.5 19.5c-85.006 37.667-171.339 41-259 10-100.196-38.694-167.529-108.861-202-210.5a1287.212 1287.212 0 0 0 99 20c1.545-.011 2.878-.344 4-1l2 2c17.436 31.612 41.102 57.779 71 78.5 75.205 49.384 154.871 57.718 239 25a536.545 536.545 0 0 1 40-18c41.965-16.497 84.965-20.497 129-12a272.048 272.048 0 0 1-36.5-31.5c-11.557-13.777-15.223-29.444-11-47a326.06 326.06 0 0 0 17.5-38c2.372-4.77 4.372-9.77 6-15 8.155-25.729 11.488-52.062 10-79-.45-20.709-4.116-40.709-11-60-1.432-5.641-3.432-10.975-6-16-12.391-31.702-30.725-59.369-55-83-22.239-23.634-48.239-42.134-78-55.5-75.57-31.576-149.57-28.243-222 10-56.52 32.013-94.853 78.847-115 140.5-.667 0-1 .333-1 1a1190.834 1190.834 0 0 1-80-34c9.383-27.766 22.217-53.766 38.5-78 59.458-85.511 141.291-134.344 245.5-146.5 128.954-8.507 231.287 38.993 307 142.5Z"
}));
export { SvgFavicon as ReactComponent };
export default __webpack_public_path__ + "1579b19c008f66003aaf6ce38bd5026e.svg";